<template>
  <div>
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="cancelar" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="container-text-relatorio">
          <span>Deseja <b>baixar</b> ou <b>imprimir</b> o relatório?</span>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="gerarRelatorio(true)" outlined color="primary">
            Baixar
            <v-icon class="ml-1">mdi-download</v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn @click="gerarRelatorio(false)" outlined color="primary">
            Imprimir
            <v-icon class="ml-1">print</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    name: 'ConfirmRelatorioModal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: true
        },
        titulo: {
            type: String,
            default: 'Gerar relatório'
        },
        maxWidth: {
            type: Number,
            default: 400
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalRelatorioAcaoCancelar')
        },
        gerarRelatorio(baixar) {
            this.model = false
            this.$emit('modalRelatorioAcaoGerar', baixar)
        }
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

.container-text-relatorio
  color black !important
  height 70px
  display flex
  justify-content center
  align-items center

</style>